import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { formatDistanceToNowStrict } from "date-fns";
import React from "react";

interface SearchHeaderProps {
  title: string;
  query: string;
  onQueryChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  lastUpdated?: string;
}

export function SearchHeader({
  title,
  query,
  onQueryChange,
  onSubmit,
  lastUpdated,
}: SearchHeaderProps) {
  return (
    <Box sx={{ mb: 8 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h4" component="h1" fontWeight={700}>
          {title}
        </Typography>

        {lastUpdated && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: "text.secondary",
              mt: 1,
            }}
          >
            <Typography variant="caption">
              Updated {formatDistanceToNowStrict(lastUpdated)} ago
            </Typography>
          </Box>
        )}
      </Box>

      <Box
        component="form"
        onSubmit={onSubmit}
        role="search"
        aria-label="Site search"
      >
        <TextField
          fullWidth
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search vulnerabilities, advisories, assets..."
          type="search"
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
              inputProps: { role: "searchbox", "aria-label": "Search" },
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              backgroundColor: "background.paper",
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default SearchHeader;
